// Auth Types
export const AUTH_INFO = 'AUTH_INFO'
export const ATTEMPT_LOGIN = 'ATTEMPT_LOGIN'
export const ATTEMPT_REGISTER = 'ATTEMPT_REGISTER'


// Alert messages types
export const SUCCESS_MSG = 'SUCCESS_MSG'
export const ERROR_MSG = 'ERROR_MSG'